import React from 'react';
import PropTypes from 'prop-types';
import ButtonIcon from '../../../common/ButtonIcon/ButtonIcon';
import { copyTextToClipboard } from '../../../utils/copy';

const FinanceScoreCard = ({ details, setMessage }) => {
  const copyData = (e) => {
    setMessage(false);
    const btn = e.target.closest('button');
    const text = btn.previousElementSibling.innerText;
    // const copiedText = copyTextToClipboard(text);
    // if(copiedText) {
    //   setMessage(true);
    // }
    copyTextToClipboard(text).then(() => setMessage(true));
  };
  const hours = Number(details.tariff_hours) || 0;
  const bonus = Number(details.tariff_bonus_hours) || 0;
  const showHours = Number(details.tariff_show_hours ?? hours);
  const isSpecial =
    String(details.tariff_is_special) === '1' ||
    details.tariff_is_special === 1;

  const totalLessons = showHours + (bonus > 0 ? bonus : 0);

  const tariffName = isSpecial
    ? `${details.tariff_name} (${showHours}${bonus > 0 ? ` + ${bonus} = ${totalLessons}` : ''
    } занять, за ${details.tariff_total_price} грн)`
    : `${details.tariff_name} (${hours} занять, ${details.tariff_price
    } грн за заняття, ${details.tariff_total_price} грн загалом)`;

  return (
    <>
      <dl className='card-pay'>

        <div className="card-pay__row card-pay__row--start">
          <dt className='card-pay-title'>Тариф:</dt>
          <dd className='card-pay-desc'><b>{tariffName}</b></dd>
        </div>
        <br></br>

        <div className="card-pay__row card-pay__row--start">
          <dt className='card-pay-title'><b>Отримувач:</b></dt>
          <dd className='card-pay-desc'><b>{details.recipient}</b></dd>
          <ButtonIcon icon='copy' onClick={copyData} />
        </div>
        <div className="card-pay__row card-pay__row--start">
          <dt className='card-pay-title'><b>Назва банку:</b></dt>
          <dd className='card-pay-desc'><b>{details.name_bank}</b></dd>
          <ButtonIcon icon='copy' onClick={copyData} />
        </div>

        <div className="card-pay__row card-pay__row--start">
          <dt className='card-pay-title'><b>IBAN:</b></dt>
          <dd className='card-pay-desc'><b>{details.iban}</b></dd>
          <ButtonIcon icon='copy' onClick={copyData} />
        </div>

        <div className="card-pay__row card-pay__row--start">
          <dt className='card-pay-title'><b>ЄДРПОУ:</b></dt>
          <dd className='card-pay-desc'><b>{details.receiver_code}</b></dd>
          <ButtonIcon icon='copy' onClick={copyData} />
        </div>

        <div className="card-pay__row card-pay__row--start">
          <dt className='card-pay-title'><b>Призначення:</b></dt>
          <dd className='card-pay-desc'><b>{details.purpose_payment}</b></dd>
          <ButtonIcon icon='copy' onClick={copyData} />
        </div>

        <div className="card-pay__row card-pay__row--start">
          <dt className='card-pay-title'>Свідотство про реєстрацію:</dt>
          <dd className='card-pay-desc'>{details.certificate_registration}</dd>
        </div>

        <div className="card-pay__row card-pay__row--start">
          <dt className='card-pay-title'>Адреса:</dt>
          <dd className='card-pay-desc'>{details.address}</dd>
        </div>
      </dl>
    </>
  );
};

FinanceScoreCard.propTypes = {
  details: PropTypes.object.isRequired,
  setMessage: PropTypes.func.isRequired,
};

export default FinanceScoreCard;